export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <div className="relative w-full h-[280px] md:h-[340px] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20home%20theater%20setup%20with%20large%20screen%20displaying%20abstract%20cinematic%20content%2C%20cozy%20living%20room%20with%20warm%20ambient%20lighting%2C%20popcorn%20bowl%20on%20wooden%20coffee%20table%2C%20comfortable%20couch%2C%20cinematic%20atmosphere%2C%20professional%20interior%20photography%2C%20warm%20golden%20and%20dark%20tones%2C%20no%20visible%20text%20or%20brands&width=900&height=600&seq=about-momo-visual&orientation=landscape"
                alt="陌陌影视 — 居家观影体验"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-black/30 to-transparent"></div>
            </div>
          </div>
          <div className="flex-1 w-full">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
              <i className="ri-information-line mr-1"></i>关于我们
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">关于陌陌</h2>
            <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
              <p>
                陌陌影视成立于2020年，是国内领先的免费高清在线电影平台。我们致力于为每一位影迷
                打造便捷、流畅、高品质的观影体验。无论是院线热映大片，还是经典影史佳作，在陌陌影视
                你都能找到属于自己的光影世界。
              </p>
              <p>
                平台汇聚超过<strong className="text-foreground-950">10,000部</strong>电影资源，覆盖动作、喜剧、爱情、科幻、
                悬疑、动画等全类型片库。我们坚持<strong className="text-foreground-950">每日更新</strong>片源，
                确保用户不错过任何一部热门新片。所有影片均提供1080P高清画质，并搭载极速播放引擎，
                告别卡顿和缓冲。
              </p>
              <p>
                陌陌影视相信，好电影值得被更多人看到。我们将持续优化平台体验，拓展内容资源，
                让观影变得更简单、更快乐。
              </p>
            </div>
            <div className="flex flex-wrap gap-4 mt-6">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                高清影库 10,000+
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                每日更新 50+ 部
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-secondary-500"></span>
                全终端支持
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}